module.exports = __webpack_public_path__ + "static/media/hulin.cde24005.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hulin.jpg
// module id = 206
// module chunks = 0